import React from 'react'
import { StepperComponent } from '.'
import { StepperUtil } from '.'
import withAppShell from "../../../hoc/withAppShell/WithAppShell";
import { SchoolInformationActions, I18nActions } from '../../../../store';
import { connect } from 'react-redux';
import routes from '../../../navigation/Routes'
import { MuiGrid } from '../../../ui';
import spinner from '../../../ui/icons/spinner.gif'
import theme from "../../../../assests";
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'

class AddStepperContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            addStepperJsonArray: {}
        }
    }

    componentWillMount() {
        let i18n;
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            i18n = getKeyFromLS("i18n");
        } else {
            i18n = this.props.i18n
        }
        let addStepperJsonArray = StepperUtil.getAddStepperJsonArray(i18n)
        this.setState({
            addStepperJsonArray: addStepperJsonArray,
            i18n: i18n
        })
    }

    render() {
        const { i18n } = this.state
        return (
            this.props.i18n === undefined ?
                <MuiGrid >
                    <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
                </MuiGrid>
                :
                <StepperComponent {...this.props} stepperJsonArray={this.state.addStepperJsonArray}
                    stepperIndex={0}
                    stepperWidth={10}
                    title={this.props.activeSchool !== undefined && this.props.activeSchool.name !== "" ?
                        this.props.activeSchool.name : i18n.schoolStepper.schoolProfile}
                    routeName={routes.addSchool}
                />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeSchool: state.schoolInformation.activeSchool,
        isCreateNewSchool: state.schoolInformation.isCreateNewSchool,
        i18n: state.i18nMessages.i18n
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActiveSchool: (school) => dispatch(SchoolInformationActions.setActiveSchool(school)),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(AddStepperContainer))